import type { UserManagerSettings } from 'oidc-client-ts'
import { WebStorageStateStore } from 'oidc-client-ts'

const authority = import.meta.env.VITE_IDENTITY_AUTHORITY
const clientId = import.meta.env.VITE_CLIENT_ID

export const OIDC_CONFIG: UserManagerSettings = {
  authority,
  client_id: clientId,
  redirect_uri: `${window.location.origin}${import.meta.env.VITE_REDIRECT_URI}`,
  post_logout_redirect_uri: `${window.location.origin}${import.meta.env.VITE_POST_LOGOUT_REDIRECT_URI}`,
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
  response_type: 'code',
  scope: import.meta.env.VITE_SCOPES,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTimeInSeconds: 60,
  loadUserInfo: true
}
